import { useCallback, useMemo } from 'react';
import { TableFetchParams, tableQueryMaker, TableState } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetUnknownDeclarationsRepoType, IGetUnknownDeclarationsRepo } from '../../repos';

export const useUnknownDeclarationsTableContext = () => {
  const getUnknownDeclarationsRepo = useService<IGetUnknownDeclarationsRepo>(GetUnknownDeclarationsRepoType);

  const handleFetch = useCallback(
    async (params: TableFetchParams) => {
      const result = await getUnknownDeclarationsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getUnknownDeclarationsRepo],
  );

  const defaultState = useMemo<Partial<TableState>>(
    () => ({
      filters: [],
    }),
    [],
  );

  return { handleFetch, defaultState };
};
